module.exports = __webpack_public_path__ + "static/media/Uplands Road N8 (21).ce20ff61.JPG";